<template>
  <div
    class="wc-page"
    :class="{
      'has-status-safe-area': needsStatusSafeArea,
      'is-ios-webview': isIOS
    }"
    :style="pageStyle"
  >
    <div v-if="!isNewsDetail" class="wc-page__header">
      <app-banner @back="closeWebView" />
      <main-tabs />
    </div>
    <div class="wc-page__body" :class="{ 'is-news-detail': isNewsDetail }">
      <router-view />
    </div>
  </div>
</template>

<script>
import NativeBridge from '@/utils/NativeBridge'
import AppBanner from './components/AppBanner.vue'
import MainTabs from './components/MainTabs.vue'

export default {
  name: 'WorldCup2026',
  components: { AppBanner, MainTabs },
  data () {
    return {
      nativeBridge: new NativeBridge(),
      nativeStatusTop: 0
    }
  },
  mounted () {
    const app = document.getElementById('app')
    if (app) app.classList.add('worldcup2026-app')
    this.updateNativeStatusTop()
  },
  beforeDestroy () {
    const app = document.getElementById('app')
    if (app) app.classList.remove('worldcup2026-app')
  },
  watch: {
    '$route.query.screen' () {
      this.updateNativeStatusTop()
    }
  },
  computed: {
    isMostOneApp () {
      const ua = (window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '').toLowerCase()
      return ua.indexOf('mostone') !== -1 || typeof window.MostOneJSApis !== 'undefined'
    },
    isIOS () {
      const ua = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : ''
      return /iPhone|iPad|iPod/i.test(ua)
    },
    needsStatusSafeArea () {
      return this.$route.query.screen === 'full' || this.isMostOneApp
    },
    pageStyle () {
      return this.nativeStatusTop > 0 ? { '--wc-status-top': `${this.nativeStatusTop}px` } : {}
    },
    isTeamDetail () {
      return /^\/worldcup2026\/team\/[^/]+/.test(this.$route.path)
    },
    isNewsDetail () {
      return /^\/worldcup2026\/news\/[^/]+/.test(this.$route.path)
    },
    isDetail () {
      return this.isTeamDetail || this.isNewsDetail
    }
  },
  methods: {
    updateNativeStatusTop () {
      if (!this.needsStatusSafeArea) {
        this.nativeStatusTop = 0
        return
      }
      const fallbackTop = this.isIOS ? 44 : 24
      this.nativeStatusTop = fallbackTop
      if (typeof window.MostOneJSApis === 'undefined' && window.webkit) return
      this.nativeBridge.sendMessage('getStatusNavBarToApp').then(res => {
        const statusBar = res && res.code === 200 && res.data ? Number(res.data.statusBar) : 0
        const ratio = window.devicePixelRatio || 1
        const statusTop = statusBar > 0 ? Math.ceil(statusBar / ratio) : 0
        this.nativeStatusTop = statusTop > 0 ? Math.max(statusTop, fallbackTop) : fallbackTop
      }).catch(() => {})
    },
    closeWebView () {
      this.nativeBridge.sendMessage('quitWebView').catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.wc-page {
  --wc-status-top: 0px;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f4f5f7;
  font-size: 14px;
  line-height: 1.4;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.wc-page.has-status-safe-area {
  --wc-status-top: 24px;
  --wc-status-top: max(env(safe-area-inset-top, 0px), 24px);
}

.wc-page.has-status-safe-area.is-ios-webview {
  --wc-status-top: 44px;
  --wc-status-top: max(env(safe-area-inset-top, 0px), 44px);
}

.wc-page__header {
  position: sticky;
  top: 0;
  z-index: 30;
}

.wc-page__body {
  min-height: calc(100vh - 178px);
}

.wc-page__body.is-news-detail {
  min-height: 100vh;
}
</style>
